import { css } from "@emotion/react";

export const section = css`
  margin-bottom: 32px;
  :last-child {
    margin-bottom: 0;
  }
`;

export const row = css`
  display: flex;
  gap: 16px;
  margin-bottom: 12px;
`;

export const fixedWidthSelect = css`
  width: 250px;
  flex-shrink: 0;
`;

export const inputGrow = css`
  flex: 1;
`;

export const sectionFooter = css`
  display: flex;
  justify-content: flex-end;
  margin-top: 8px;
  cursor: pointer;
`;
